import * as React from "react";
const PlusSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 20", fill: "currentColor", width: size || "20", height: size || "20", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M11,5 L10.999,10 L16,10 L16,11 L11,11 L11,16 L10,16 L9.999,11 L5,11 L5,10 L10,9.999 L10,5 L11,5 Z" }));
PlusSmall.displayName = "PlusSmall";
var PlusSmall_default = PlusSmall;
export {
  PlusSmall_default as default
};
